<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <!-- Summary info -->
                <v-flex lg6 pa-0 pl-3 pt-3>
                    <v-btn
                        :color="paymentRequest.Status | display_color(request_status)"
                        width="160px"
                        height="36px"
                        small
                        dark
                        depressed
                        outlined
                    >{{ paymentRequest.Status | display_value(request_status)}}</v-btn>
                </v-flex>
                <!-- Action buttons -->
                <v-flex lg6 pa-0 pr-3 pt-6>
                    <v-layout row wrap justify-end class="action-bar">
                        <v-btn v-if="paymentRequest.Status == 1" color="blue white--text" @click="updateAddress">Cập nhật</v-btn>
                        <v-btn v-if="!paymentRequest.ID" color="blue white--text" @click="saveNewRequest">Lưu lại</v-btn>
                        <v-btn v-if="paymentRequest.ID" @click="printPayOrder">
                            <v-icon color="red" class="mr-2">print</v-icon>In đơn
                        </v-btn>
                    </v-layout>
                </v-flex>
                <v-flex lg6>
                    <v-autocomplete label="Khách hàng" v-model="paymentRequest.UID" :items="customers" :item-text="getCustomerText" item-value="ID" @change="onSelectedCustomer" :readonly="paymentRequest.ID > 0"></v-autocomplete>
                </v-flex>
                <v-flex lg6>
                    <v-autocomplete v-if="!paymentRequest.ID" label="Địa chỉ" v-model="selectedAddressID" :items="addressBooks" :item-text="getAddressText" item-value="ID" @change="onSelectedAddress" :readonly="paymentRequest.Status > 1"></v-autocomplete>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="paymentRequest.ReceiverAddress" label="Địa chỉ" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-autocomplete label="Phương thức giao" v-model="paymentRequest.ShippingMethod" :items="shipping_methods" item-text="name" item-value="value" :readonly="paymentRequest.Status > 1"></v-autocomplete>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="paymentRequest.ReceiverName" label="Người nhận" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="paymentRequest.ReceiverPhone" label="Điện thoại" class="input-group--focused"></v-text-field>
                </v-flex>
                
                <v-flex lg6 md6 sm12>
                    <v-textarea rows="2" v-model="paymentRequest.CustomerNote" label="Ghi chú KH" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-textarea rows="2" v-model="paymentRequest.Note" label="Ghi chú DL" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-flex lg12 class="font-weight-bold" v-if="paymentRequest.ID > 0">
                    <div>Số kiện yêu cầu: {{paymentRequest.TotalPackage | currency}}</div>
                </v-flex>
                <v-flex lg12 class="font-weight-bold" v-if="!paymentRequest.ID && (adminRole || paymentRole)">
                    <v-checkbox label="Cho xuất kho nợ" v-model="isPayLaster"></v-checkbox>
                </v-flex>
                <v-flex lg12 v-if="paymentRequest.ID > 0">
                    <v-data-table
                    :headers="orderHeader"
                    :items="paymentRequest.Orders"
                    :mobile-breakpoint="100"
                    :items-per-page="100"
                    :server-items-length="paymentRequest.Orders ? paymentRequest.Orders.length : 0"
                    :hide-default-footer="true"
                    item-key="ID"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                        <td>{{ item.TransactionCode }}</td>
                        <td>
                            <a target="_blank" :href="(item.OrderType == 1 ? '/don-hang/chi-tiet/' : '/ky-gui/') + item.OrderID">{{(item.OrderType == 1 ? 'MD' : 'KG') + item.OrderID}}</a>
                        </td>
                        <td class="text-end">{{ item.NumberOfPack | currency}}</td>
                        <td class="text-end">{{ item.Weight | currency('', 2)}}</td>
                        <td class="text-end">{{ item.Volume | currency('', 3)}}</td>
                        <td class="text-end">{{ item.WeightByVolume | currency('', 1)}}</td>
                        <td class="text-end">{{ (item.PriceType !== 3 ? (item.PriceType == 1 ? item.Weight : item.WeightByVolume) : 0) | currency('', 2) }}</td>
                        <td class="text-end">{{ (item.PriceType === 3 ? item.Volume : 0) | currency('', 3) }}</td>
                        <td>{{ item.OrderNote}}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="total-summary-td">
                            <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{totalPackageNumber | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalWeight | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{totalVolume | currency('', 3)}}</td>
                            <td class="text-end font-weight-bold">{{totalWeightByVolume | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{totalPayWeight | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{totalPayVolume | currency('', 3)}}</td>
                            <td class="text-end font-weight-bold"></td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-flex>
                <v-flex lg12 v-else>
                    <v-data-table
                    :headers="newOrderHeader"
                    :items="newOrders"
                    :mobile-breakpoint="100"
                    :items-per-page="100"
                    :server-items-length="newOrders ? newOrders.length : 0"
                    :hide-default-footer="true"
                    item-key="PKey"
                    show-select v-model="selectedOrders"
                    >
                    <template v-slot:item="{ item, isSelected, select }">
                        <tr :active="isSelected" @click="select(!isSelected)">
                        <td>
                            <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                        </td>
                        <td>
                            <a target="_blank" :href="(item.OrderType == 1 ? '/don-hang/chi-tiet/' : '/ky-gui/') + item.ID">{{(item.OrderType == 1 ? 'MD' : 'KG') + item.ID}}</a>
                        </td>
                        <td class="text-end">{{ item.Weight | currency('', 2)}}</td>
                        <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                        <td class="text-end">{{ item.Deposit | currency}}</td>
                        <td class="text-end">{{ item.RemainAmount | currency}}</td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import { print_export_receipt_order_v1 } from '@/commons/hpod';
    import configs from "@/configs";
    export default {
        data() {
            return {
                orderHeader: [
                    {
                        text: "Mã vận đơn",
                        right: false
                    },
                    {
                        text: "Mã đơn hàng",
                        right: false
                    },
                    {
                        text: "Số kiện",
                        align: "end"
                    },
                    {
                        text: "Cân nặng",
                        align: "end"
                    },
                    {
                        text: "Kích thước",
                        align: "end"
                    },
                    {
                        text: "Cân quy đổi",
                        align: "end"
                    },
                    {
                        text: "Cân tính tiền",
                        align: "end"
                    },
                    {
                        text: "Khối tính tiền",
                        align: "end"
                    },
                    {
                        text: "Ghi chú"
                    }
                ],
                newOrderHeader: [
                    {
                        text: "Đơn hàng",
                        value: "ID",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng cân",
                        value: "Weight",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng tiền",
                        value: "TotalAmountVND",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Đã trả",
                        value: "Deposit",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Còn thiếu",
                        value: "RemainAmount",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                ],
                pagination: {...configs.PAGINATION, sortBy: ["ID"]},
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                request_status: configs.PAYMENT_REQUEST_STATUS,
                shipping_methods: configs.SHIPPINGMETHODS,
                selectedAddressID: 0,
                newOrders: [],
                selectedOrders: [],
                isPayLaster: false
            };
        },
        computed: {
            ...mapState({
                loading: state => state.paymentRequest.loading,
                paymentRequest: state => state.paymentRequest.selected,
                customers: state => state.customer.master.data,
                addressBooks: state => state.addressBook.all.data,
            }),
            modifyId() {
                return this.$route.params.Pid;
            },
            totalPackageNumber() {
                return _.sumBy(this.paymentRequest.Orders, "NumberOfPack");
            },
            totalVolume() {
                return _.sumBy(this.paymentRequest.Orders, "Volume");
            },
            totalWeightByVolume() {
                return _.sumBy(this.paymentRequest.Orders, "WeightByVolume");
            },
            totalPayWeight() {
                return _.sumBy(this.paymentRequest.Orders, (item) => {
                    return item.FeeShipType != 1 ? (item.FeeShipType == 0 ? item.Weight : item.WeightByVolume) : 0;
                });
            },
            totalWeight() {
                return _.sumBy(this.paymentRequest.Orders, "Weight");
            },
            totalPayVolume() {
                return _.sumBy(this.paymentRequest.Orders, (item) => {
                    return item.FeeShipType == 1 ? item.Volume : 0;
                });
            },
            adminRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
            },
            paymentRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
            },
            storeVNRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
            }
        },
        watch: {
            modifyId() {
                this.refreshData();
            }
        },
        methods: {
            refreshData() {
                if (this.modifyId > 0) {
                    this.$store.dispatch("paymentRequest/getDetail", this.modifyId).then(p => {
                        if (this.$route.query.is_print == 1) {
                            // Gọi printPayOrder nếu query string có is_print=1 và xóa query string sau khi in
                            this.$nextTick(() => {
                                this.printPayOrder(false);
                                this.$router.replace({ query: { ...this.$route.query, is_print: undefined }});
                            });
                        }
                    });
                }
                else {
                    this.$store.commit("paymentRequest/setDetail", { data: {
                            ID: 0
                        }
                    })
                }
            },
            saveData() {
                this.$store.dispatch("paymentRequest/setDetail", {
                    data: this.paymentRequest,
                    id: this.paymentRequest.ID
                });
                window.getApp.$emit("APP_NAVIGATE", "PaymentRequestList");
            },
            saveNewRequest() {
                if(this.selectedOrders.length == 0) {
                    sendErrorNotice('Hãy chọn danh sách đơn hàng.')
                    return;
                }
                if(!this.selectedAddressID) {
                    sendErrorNotice('Hãy chọn địa chỉ giao hàng.')
                    return;
                }
                this.paymentRequest.TotalAmount = _.sumBy(this.selectedOrders, "TotalAmountVND");
                this.paymentRequest.TotalPayment = _.sumBy(this.selectedOrders, "Deposit");
                this.paymentRequest.TotalOrder = this.selectedOrders.length;
                this.paymentRequest.Status = 1;
                this.$store.dispatch("paymentRequest/setDetail", {
                    data: {
                        ...this.paymentRequest,
                        IsPayLaster: this.isPayLaster,
                        Orders: this.selectedOrders
                    },
                    id: 0
                });
                window.getApp.$emit("APP_NAVIGATE", "PaymentRequestList");
            },
            get_order_status_color(value){
                const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
                return objStatus ? objStatus.color : 'black';
            },
            getCurrentShippingMethod() {
                const sm = _.find(this.shipping_methods, {value: this.paymentRequest.ShippingMethod});
                return sm ? sm.name : '';
            },
            updateAddress() {
                let reqData = {...this.paymentRequest};
                delete reqData.Status;
                this.$store.dispatch("paymentRequest/setDetail", {data: reqData, id: this.paymentRequest.ID});
            },
            getCustomerText(item) {
                return `DL${item.ID} - ${item.Username}`
            },
            onSelectedCustomer() {
                this.paymentRequest.ReceiverName = '';
                this.paymentRequest.ReceiverPhone = '';
                this.paymentRequest.ReceiverAddress = '';
                this.selectedOrders = [];
                this.newOrders = [];
                if(this.paymentRequest.UID > 0) {
                    this.$store.dispatch("addressBook/getList", {
                    filter: [{
                            column: "UID",
                            value: this.paymentRequest.UID,
                            condition: "equal"
                        }]
                    });
                    const order_filter = [{
                            column: "UID",
                            value: this.paymentRequest.UID,
                            condition: "equal"
                        },
                        {
                            column: 'Status',
                            value: [7,8],
                            condition: 'in'
                        },
                        {
                            column: 'TotalPackageUnRequest',
                            value: 0,
                            condition: 'greater_than'
                        }]
                    this.$store.dispatch("main_order/getListOrders", { filter: order_filter }).then((r) => {
                        for (let i = 0; i < r.data.length; i++) {
                            const element = r.data[i];
                            this.newOrders.push({
                                PKey: `${element.ID}_1`,
                                ID: element.ID,
                                OrderType: 1,
                                PackageNumber: element.PackageNumber,
                                Weight: element.OrderWeight,
                                TotalAmountVND: element.TotalAmountVND,
                                Deposit: element.Deposit,
                                RemainAmount: element.TotalAmountVND - element.Deposit,
                            });
                        }
                    });
                    this.$store.dispatch("deposit/getList", { filter: order_filter }).then((r) => {
                        for (let i = 0; i < r.data.length; i++) {
                            const element = r.data[i];
                            this.newOrders.push({
                                PKey: `${element.ID}_2`,
                                ID: element.ID,
                                OrderType: 2,
                                PackageNumber: element.PackageNumber,
                                Weight: element.OrderWeight,
                                TotalAmountVND: element.TotalPriceVND,
                                Deposit: element.Payment,
                                RemainAmount: element.TotalPriceVND - element.Payment,
                            });
                        }
                    });
                }
                else {
                    this.$store.commit("addressBook/setList", {});
                }
            },
            getAddressText(item) {
                return `${item.Receiver} - ${item.Phone}`
            },
            onSelectedAddress() {
                const addr = _.find(this.addressBooks, {'ID': this.selectedAddressID});
                const customer = _.find(this.customers, {'ID': this.paymentRequest.UID});
                if(addr) {
                    this.paymentRequest.UID = addr.UID;
                    this.paymentRequest.Username = customer.Username;
                    this.paymentRequest.ReceiverName = addr.Receiver;
                    this.paymentRequest.ReceiverPhone = addr.Phone;
                    this.paymentRequest.ReceiverAddress = addr.Address;
                }
            },
            printPayOrder(is_payment = true) {
                const result = _.uniqWith(_.map(this.paymentRequest.Orders, (p) => {
                    return {OrderID: p.OrderID, OrderType: p.OrderType, TotalAmountVND: p.TotalAmountVND, Deposit: p.Deposit}
                }), _.isEqual);
                const totalAmountVND = _.sumBy(result, function(o) { return o.TotalAmountVND; });
                const totalDeposit = _.sumBy(result, function(o) { return o.Deposit; });
                const totalPayLeft = totalAmountVND - totalDeposit;
                const customer = _.find(this.customers, {'ID': this.paymentRequest.UID});
                const frame_printing = print_export_receipt_order_v1({'ID': this.paymentRequest.ID, 'CustomerID': this.paymentRequest.UID, 'CustomerName': this.paymentRequest.ReceiverName, 'PhoneNumber': this.paymentRequest.ReceiverPhone, 'Address': this.paymentRequest.ReceiverAddress, 'PayLeft': totalPayLeft, 'Wallet': customer.Wallet, 'Remain': (customer.Wallet > totalPayLeft ? 0 : totalPayLeft - customer.Wallet), 'Orders': this.paymentRequest.Orders}, this.paymentRequest.Orders, true, is_payment);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            }
        },
        mounted() {
            this.refreshData();
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID", "Wallet"]
            });
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
            if (this.$route.query.uid && this.$route.query.uid !== '') {
                this.paymentRequest.UID = Number(this.$route.query.uid);
            }
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
        },
    };
    </script>